import { Controller } from "@hotwired/stimulus"
import { debounce } from "javascripts/helpers"

export default class extends Controller {
  static values = {
    delay: {
      type: Number,
      default: 300
    }
  }

  connect () {
    if (this.delayValue) {
      this.submit = debounce(this.submit.bind(this), this.delayValue)
    }
  }

  submit(event) {
    if (this.element.isConnected) {
      this.element.requestSubmit();
    }
  }
}
